export default __webpack_public_path__ + "static/media/route-vs-component-split.d3f33c89.png";